import { Request } from "../base/models.jsx";
import { Coordinate } from "../../utils/geographics/models.jsx";

const SERVICE_ID = 2;

const states = {
	victimStates: {
 		DANGER: 1,
 		WARN: 2,
  		INFO: 3,
  		ALERT: 4,
  		OK: 5
	},
	perimetralStates: {
		DANGER: 1, // Igual que danger en victimStates
		WARN: 2, // Igual que warning en victimStates
		UNK: 3, // Igual que info en victimStates
		OK: 4
	},
	mobilityState: {
		OK: 1,
		DELAYED: 2,
		OLD: 3
	}
}

class Alert extends Request {

	constructor(jsonData) {
		if (jsonData == null) {
			jsonData = {};
			super(jsonData);
			this.creation();
		} else {
			super(jsonData);
		}

		if (jsonData.location) {
			this.location = new Coordinate(jsonData.location)
			this.locationTime = jsonData.locationDate;
		}

		this.name = jsonData.name;
		this.lastName = jsonData.lastName;
		this.phoneNumber = jsonData.phoneNumber;

		if (jsonData.violent)
			jsonData.violent = new ViolentProfile(jsonData.violent);

		this.received = jsonData.received;
		this.attending = jsonData.attending;
		this.resolved = jsonData.resolved;
	}

	creation() {
		super.creation();
		this.serviceId = SERVICE_ID;
	}

}

class ViolentProfile {

	constructor(jsonData) {
		if (jsonData == null || jsonData === undefined)
			jsonData = {};
		
		this.id = jsonData.id;
		this.name = jsonData.name;
		this.lastName = jsonData.lastName;
		this.phoneNumber = jsonData.phoneNumber;

	}

}

class Profile {

	constructor(jsonData) {
		if (jsonData == null || jsonData === undefined)
			jsonData = {};
		
		this.name = jsonData.name;
		this.lastName = jsonData.lastName;
		this.birthDate = jsonData.birthDate;
		this.gender = jsonData.gender;
		this.phoneNumber = jsonData.phoneNumber;
	}

}

class Mobility {

	constructor(jsonData) {
		if (jsonData == null || jsonData === undefined)
			jsonData = {};
		
		if (jsonData.location)
			this.location = new Coordinate(jsonData.location)
		
		this.accuracy = jsonData.accuracy;
		this.time = jsonData.time;
		this.movement = jsonData.movement;
	}

	prepare() {

 		let now = Date.now();
		let isCommute = this.movement && this.movement.type === "COMMUTE";
		let semiOldData = isCommute ? 60000 : 1200000;
		let oldData = 43200000;
		let dataAge = now - this.time;	

		if (dataAge > oldData)
        	this.state = states.mobilityState.OLD;
        else if (dataAge > semiOldData)
         	this.state = states.mobilityState.DELAYED;
        else
         	this.state = states.mobilityState.OK;
	}

}

class Perimetral {

	constructor(jsonData) {
		if (jsonData == null || jsonData === undefined)
			jsonData = {};
		
		this.id = jsonData.id;
		this.accusedId = jsonData.accusedId;
		this.distance = jsonData.distance;
		this.minDistance = jsonData.minDistance;
		this.warningDistance = jsonData.warningDistance;

		if (jsonData.profile)
			this.profile = new Profile(jsonData.profile)

		if (jsonData.mobility)
			this.mobility = new Mobility(jsonData.mobility)

	}

	prepare() {
		if (this.mobility)
			this.mobility.prepare();

		let accusedMobState = this.mobility ? this.mobility.state : states.mobilityState.OLD;


		if (accusedMobState === states.mobilityState.OLD || this.distance === undefined) {
			this.state = states.perimetralStates.UNK;
			this.distance = undefined;
		} else if (this.distance > this.warningDistance)
			this.state = states.perimetralStates.OK;
		else if (this.distance > this.minDistance)
			this.state = states.perimetralStates.WARN;
		else
			this.state = states.perimetralStates.DANGER;
	 }

    distanceAsText() {
	    if (this.distance === undefined)
	      return " (sin datos) ";

	    if (this.distance < 1000)
	      return `${this.distance | 0} mts`
	    else 
	      return `${(this.distance/1000).toFixed(1)} kms`
	 }

}

class VictimState {

	constructor(jsonData) {
		
		if (jsonData == null || jsonData === undefined)
			jsonData = {};
		
		this.userId = jsonData.userId;

		if (jsonData.profile)
			this.profile = new Profile(jsonData.profile);

		if (jsonData.mobility)
			this.mobility = new Mobility(jsonData.mobility);

		if (jsonData.accusedProfile)
			this.accusedProfile = new ViolentProfile(jsonData.accusedProfile);

		if (jsonData.alert) {
			this.alert = new Alert(jsonData.alert);	
			if (this.alert.locationTime) {
				this.mobility = new Mobility({
					location: this.alert.location,
					time: this.alert.locationTime
				});
			}
		}

		this.restrictions = [];
		if (jsonData.restrictions) {
			for (var index = 0; index < jsonData.restrictions.length; index++) {
				this.addRestriction(new Perimetral(jsonData.restrictions[index]));
			}
		}

		this.prepare();
	}

	isImportant() {
		return this.alert != null || this.state == states.victimStates.DANGER || this.state == states.victimStates.WARN || this.state == states.victimStates.ALERT;
	}

	addRestriction(restriction) {
		this.restrictions.push(restriction);
	}

	prepare() {

		if (this.mobility)
			this.mobility.prepare();

		let worstPerimetral = states.perimetralStates.OK;
		this.restrictions.forEach((perimetral) => {
			if (!this.mobility || this.mobility.state === states.mobilityState.OLD)
				perimetral.distance = undefined;
			
			perimetral.prepare();

			
			if (perimetral.state < worstPerimetral)
				worstPerimetral = perimetral.state;
		});

		if (this.alert)
			this.state = states.victimStates.ALERT;
		else if (worstPerimetral < states.perimetralStates.OK)
			this.state = worstPerimetral;
		else if (!this.mobility || this.mobility.state === states.mobilityState.OLD)
			this.state = states.victimStates.INFO;
		else
			this.state = states.victimStates.OK;
	}

	minDistance() {
		let distance = undefined;
		this.restrictions.forEach((perimetral) => {
			if (distance === undefined || (perimetral.distance !== undefined && distance > perimetral.distance))
				distance = perimetral.distance;
		});
		return distance;
	}

	static compare(stateA, stateB) {
    	if (stateA.state === states.victimStates.ALERT)
    		return -1;
    	else if (stateB.state === states.victimStates.ALERT)
    		return 1;

    	let res = stateA.state - stateB.state;
    	if (res !== 0)
    		return res;

    	let distanceA = stateA.minDistance();
    	let distanceB = stateB.minDistance();

    	if (distanceA !== undefined && distanceB !== undefined)
    		return distanceA - distanceB;
    	else
    		return stateA.id - stateB.id;
  	}

}

export { VictimState, Alert, states, SERVICE_ID };
